import React from "react";

type SettingCardProps = {
  href: string;
  header: string;
  description: string;
  example?: React.ReactNode;
};
export const SettingsCard: React.FC<SettingCardProps> = ({
  href,
  header,
  description,
  example,
}) => {
  return (
    <a href={href}>
      <h3 className="txu-block-title">{header}</h3>
      <p className="txu-block-description">
        {description}
        {example != null && (
          <>
            <br />
            <br />
            {example}
          </>
        )}
      </p>
    </a>
  );
};
